// Code-managed blog posts: the public /blog reads these synchronously (prerenderable), then merges any posts published from
// the admin editor at runtime. To add a post: create a file in this folder and import it here.
import skillGames from "./skill-games-for-convenience-stores";
import preReveal from "./what-is-a-pre-reveal-game";
import fortuneVs from "./fortune-machines-vs-other-skill-game-cabinets";
import aogKiosk from "./how-to-add-an-aog-sweeps-game-kiosk";
import atmKiosk from "./adding-an-atm-kiosk-to-your-store";

export const AUTHOR = "Arcade Ops team";

export const wordCount = (md = "") => md.replace(/[#*_>`|\-]/g, " ").split(/\s+/).filter(Boolean).length;
const finish = (p) => ({ ...p, id: p.slug, author_name: AUTHOR, cover_url: null, reading_minutes: Math.max(1, Math.round(wordCount(p.body) / 220)), body_md: p.body.trim(), source: "code" });

export const POSTS = [skillGames, preReveal, fortuneVs, aogKiosk, atmKiosk].map(finish).sort((a, b) => (a.published_at < b.published_at ? 1 : -1));
export const postBySlug = (slug) => POSTS.find((p) => p.slug === slug) || null;
export const POST_TAGS = Array.from(new Set(POSTS.flatMap((p) => p.tags))).sort((a, b) => a.localeCompare(b));
export const morePosts = (slug, n = 2) => POSTS.filter((p) => p.slug !== slug).slice(0, n);
